// extracted by mini-css-extract-plugin
module.exports = {"slider":"RangeSlider_slider__26AqR"};